import { type OverallStudyPeriodRestrictionLegacy } from '@verantos-dev/types-cohorts';
import { Cohort_definitionContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const generateStudyPeriod = (
  cohortDefinitionTree: Cohort_definitionContext
): OverallStudyPeriodRestrictionLegacy | undefined => {
  if (!cohortDefinitionTree.study_period_criteria) return undefined;

  const studyPeriodCriteria = cohortDefinitionTree?.study_period_criteria()?.overall_study_period();

  return {
    isEnabled: true,
    startDate: studyPeriodCriteria?.DATE(0)?.getText() || '',
    endDate: studyPeriodCriteria?.DATE(1)?.getText() || '',
  };
};
